import React from 'react'
import { useTranslation } from 'react-i18next';
import { Divider, Paper } from '@material-ui/core';


const ThankYouOrder = ({ items }) => {
  const { t, i18n } = useTranslation();
  const pendingSrc = process.env.PUBLIC_URL + '/Pending.png';
  const foundSrc = process.env.PUBLIC_URL + '/Found.png';
  const replacedSrc = process.env.PUBLIC_URL + '/Substituted.png';
  const noStockSrc = process.env.PUBLIC_URL + '/NoStock.png';

  const checkStatus = (item) => {
    let source;
    const quantity = item.quantity;
    const status = [item.quantity_found, item.quantity_replaced, item.quantity_missing, item.quantity_error]
    const statusSum = status.reduce((a, b) => a + b, 0);
    if (statusSum == quantity) {
      switch (quantity) {
        case status[0]:
          source = foundSrc;
          break;
        case status[1]:
          source = replacedSrc;
          break;
        case status[2]:
          source = noStockSrc;
          break;
        case status[3]:
          source = noStockSrc;
          break;
        default:
          source = pendingSrc;
      };
    } else {
      source = pendingSrc;
    }
    return <img src={source} alt="status" className="StatusImg" />
  }

  return (
    <div className="ThankYouComponent">
      <div className="Legend">
        <p className="LegendText">{t("One of our shoppers will prepare your order soon")}</p>
        <figure style={{ textAlign: 'center' }}>
          <img src={pendingSrc} alt="Pending" className="StatusImg" />
          <figcaption className="StatusCaption">{t("Pending")}</figcaption>
        </figure>
        <figure style={{ textAlign: 'center' }}>
          <img src={foundSrc} alt="Found" className="StatusImg" />
          <figcaption className="StatusCaption">{t("Found")}</figcaption>
        </figure>
        <figure style={{ textAlign: 'center' }}>
          <img src={replacedSrc} alt="Replaced" className="StatusImg" />
          <figcaption className="StatusCaption">{t("Replaced")}</figcaption>
        </figure>
        <figure style={{ textAlign: 'center' }}>
          <img src={noStockSrc} alt="No stock" className="StatusImg" />
          <figcaption className="StatusCaption">{t("No stock")}</figcaption>
        </figure>
      </div>

      <div className="ProductContainer">
        <table className="ProductTable">
          <thead>
            <tr>
              <th className="th" style={{ width: 200 }} colspan={2} align="left">Product</th>
              <th style={{ width: 90 }}>Quantity</th>
              <th style={{ width: 90 }}>Status</th>
            </tr>
          </thead>
          <tbody>
            {
              items.map((item, i) => {
                return (
                  <tr key={i}>
                    <td><img src={item.image_url} alt={item.title} className="ProductImage" /></td>
                    <td>{item.title} <br /> {item.vendor} <br /> ${item.price} </td>
                    <td align="center">{item.quantity}</td>
                    <td align="center">{checkStatus(item)}</td>
                  </tr>
                )
              })
            }
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default ThankYouOrder